module.exports = __webpack_public_path__ + "static/media/business-open-markets.3fafdbd9.svg";